import React from 'react';
import { PDFDownloadLink } from '@react-pdf/renderer';
import CustomFormOutputPDF from "./CustomFormOutputPDF";
import SaveAltIcon from "@material-ui/icons/SaveAlt";
import { Button, makeStyles } from "@material-ui/core";

const pdfButtonStyles = makeStyles({
    disabledButton: {
        color: '#cccccc',
        borderColor: '#cccccc',
        cursor: 'not-allowed',
    }
});

const DownloadPDFButton = ({
    vehicle,
    answers,
    sections,
    imageTypes,
    generatedDate,
    lot,
    formTypeLabel,
    showFailuresOnly,
    formType
}) => {
    const classes = pdfButtonStyles();

    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    const dateString = `${year}${month}${day}`;

    const filename = `${formTypeLabel.replace(/\s/g, '')}-${vehicle.descriptor || 'report'}-${dateString}.pdf`;

    return (
        <PDFDownloadLink
            document={
                <CustomFormOutputPDF
                    vehicle={vehicle}
                    answers={answers}
                    sections={sections}
                    imageTypes={imageTypes}
                    generatedDate={generatedDate}
                    lot={lot}
                    showFailuresOnly={showFailuresOnly}
                    formTypeLabel={formTypeLabel}
                    formType={formType}
                />
            }
            fileName={filename}
        >
            {({ loading, error }) => {
                if (loading) {
                    return <Button className={classes.disabledButton} startIcon={<SaveAltIcon color="disabled" style={{ fill: "#cccccc" }} />} variant="outlined" type="button">{'Generating PDF...'}</Button>;
                }

                if (error) {
                    console.error('DownloadPDFButton', error);
                    return <span className={classes.disabledButton} >Error Generating PDF</span>;
                }

                return <Button startIcon={<SaveAltIcon />} variant="outlined" type="button">Save As PDF</Button>;
            }}
        </PDFDownloadLink>
    );
};

export default DownloadPDFButton;